import ReactDOM from 'react-dom';
import promiseFinally from 'promise.prototype.finally';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import { StyleSheetManager, ThemeProvider } from 'styled-components/macro';
import * as stores from './stores';
import * as help from './helpers';
import App from './App';
import TagManager from 'react-gtm-module';
import theme from 'theme';

// Exposing states for easier debugging
window._____APP_STATE_____ = stores;

// Adding support for a "finally" method in promises
promiseFinally.shim();

// Add git hash to window on build
window.YS_ACCOUNT_UI_VERSION = process.env.REACT_APP_GIT_SHA;
window.YS_ACCOUNT_BUILD_TIME = process.env.REACT_APP_BUILD_TIME;

// creating a container for styled components so they
// can override any framework we use.
const styleContainer = document.createElement('div');
document.body.appendChild(styleContainer);

// if it's an external redirect, let's do it before React is rendered
help.handleExternalRedirects();

const tagManagerArgsProduction = {
    gtmId: 'GTM-NS2JKQW',
    auth: 'eUCJYtV4r1qi12PP3muixw',
    preview: 'env-2',
};

const tagManagerArgsStaging = {
    gtmId: 'GTM-NS2JKQW',
    auth: 'QvZ9PsS_BbGb5mPA4_wIVg',
    preview: 'env-226',
};

window.yconfig.Env === 'prod'
    ? TagManager.initialize(tagManagerArgsProduction)
    : TagManager.initialize(tagManagerArgsStaging);

ReactDOM.render(
    <Provider {...stores}>
        <BrowserRouter>
            <StyleSheetManager target={styleContainer}>
                <ThemeProvider theme={theme}>
                    <App />
                </ThemeProvider>
            </StyleSheetManager>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root'),
);
